import {ActionMethod} from 'constants/AnalyticsConstants';
import {ColumnDataTypeSpec} from 'notebook/structured-tables/columns/ColumnDataType';
import {ColumnDefinition} from 'notebook/structured-tables/columns/ColumnDefinitions';
import {
  StructuredTableColumn,
  StructuredTableKind,
  UnknownStructuredTable,
} from 'notebook/structured-tables/StructuredTableConstants';

export interface StructuredTableMapping {
  id?: string;
  cid?: string;
  sourceTableProvenanceUuid: string;
  destinationTableProvenanceUuid: string;
  replicationFactor?: number;
  structuredTableColumnMappings: Array<StructuredTableColumnMapping>;
}

export interface StructuredTableColumnMapping {
  id?: string;
  cid?: string;
  sourceTableColumnProvenanceUuid: string;
  destinationTableColumnProvenanceUuid: string;
}

/** The types of structured tables that can be used as sources */
export const SOURCE_TABLE_TYPES: Set<StructuredTableKind> = new Set([
  StructuredTableKind.BOX_CREATION,
  StructuredTableKind.INVENTORY,
  StructuredTableKind.LOOKUP,
  StructuredTableKind.PLATE_CREATION,
  StructuredTableKind.PROCESS_TASK,
  StructuredTableKind.REGISTRATION,
  StructuredTableKind.RESULTS,
  StructuredTableKind.TRANSFER,
]);

/** The types of structured tables that can be used as destinations */
export const DESTINATION_TABLE_TYPES: Set<StructuredTableKind> = new Set([
  StructuredTableKind.BOX_CREATION,
  StructuredTableKind.INVENTORY,
  StructuredTableKind.LOOKUP,
  StructuredTableKind.PLATE_CREATION,
  StructuredTableKind.PROCESS_OUTPUT,
  StructuredTableKind.REGISTRATION,
  StructuredTableKind.RESULTS,
  StructuredTableKind.TRANSFER,
]);

export interface StructuredTableMappingActionOptions {
  sourceTableRowIndexes: Array<number>;
  analytics: {
    actionMethod: ActionMethod;
  };
}

// COMPATIBILITY INFO

/** A combined string of a table's uuid followed by the column's uuid */
export type TableColumnProvenanceUuid = `${string}|${string}`;

export type CompatibleColumnInfoMap = Record<TableColumnProvenanceUuid, CompatibleStructuredTableColumnInfo>;

export interface CompatibleStructuredTableInfo {
  structuredTable: UnknownStructuredTable;
  compatibleStructuredTableColumns: Array<CompatibleStructuredTableColumnInfo>;
}

export interface CompatibleStructuredTableColumnInfo {
  columnIndex: number;
  structuredTableColumn: StructuredTableColumn;
  columnDefinition: ColumnDefinition;
  columnDataType: ColumnDataTypeSpec;
  structuredTable: UnknownStructuredTable;
}

// CIDs

export const STRUCTURED_TABLE_MAPPING_CID_PREFIX = 'st_mapping';
export const STRUCTURED_TABLE_COLUMN_MAPPING_CID_PREFIX = 'st_col_mapping';
